import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { Box } from 'braid-design-system';
import type { ReactNode } from 'react';

import { getConfigValues } from 'src/config';

interface StripeProviderProps {
  children: ReactNode;
}

export const StripeProider = (props: StripeProviderProps) => {
  if (typeof window !== 'undefined') {
    return (
      <Elements stripe={loadStripe(getConfigValues().STRIPE_API_KEY)}>
        {props.children}
      </Elements>
    );
  }

  return <Box>{props.children}</Box>;
};
